import { type } from 'os';
import React from 'react';
import { isNamespaceExport } from 'typescript';

type PageProps = {
	cols:Number,
	skip?:Number,
	breakpoints?:object,
	className?:string,
	style?:object,
}

export default class Grid extends React.Component<PageProps>
{

	static parseBreakpoints(data)
	{
		if(!data) return [];
		let classes = [];
		for (let [breakpoint, value] of Object.entries(data))
		{
			let bpSuffix = '-' + breakpoint;
			if(breakpoint == 'default') bpSuffix = '';
			if(typeof value == 'object')
			{
				if('cols' in value) classes.push('grid-' + value['cols'] + bpSuffix);
				if('skip' in value) classes.push('skip-' + value['skip'] + bpSuffix);
			}else if(!isNaN(value as any)){
				classes.push('grid-' + value + bpSuffix);
			}
		}
		return classes;
	}

	render()
	{
		let classes = ['grid-' + this.props.cols];
		if(this.props.skip) classes.push('skip-' + this.props.skip);
		if(this.props.breakpoints) classes = classes.concat(Grid.parseBreakpoints(this.props.breakpoints));
		if(this.props.className) classes = classes.concat(this.props.className);
		classes = classes.filter((e, i) => classes.indexOf(e) === i);

		return (
			<div className={classes.join(' ')} style={this.props.style}>
				{this.props.children}
			</div>
		);
	}
}
